import { type AnyAction } from 'redux';
import { SET_MA_NAVIGATION } from './ma-navigation-actions';

type State = { profileLinkTemplate: string; settingsLink: string; notificationsLink: string };

const defaultState: State = {
  profileLinkTemplate: '',
  settingsLink: '',
  notificationsLink: '',
};

export function maNavigation(state: State = defaultState, action: AnyAction): State {
  switch (action.type) {
    case SET_MA_NAVIGATION:
      return action.payload;
    default:
      return state;
  }
}
